// extracted by mini-css-extract-plugin
export default {"nav":"DisclosureLayout_nav__0I17J","page":"DisclosureLayout_page__otMtZ"};